import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from '../../app/axiosBaseQuery';

export const investorsApi = createApi({
  reducerPath: 'investorsApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['Investor'],
  endpoints: (builder) => ({
    listInvestors: builder.query({
      query: (params) => ({ url: '/admin/investors', method: 'GET', params }),
      providesTags: (result) =>
        result
          ? [...result.data.map((i) => ({ type: 'Investor', id: i.id })), { type: 'Investor', id: 'LIST' }]
          : [{ type: 'Investor', id: 'LIST' }],
    }),
    getInvestor: builder.query({
      query: (id) => ({ url: `/admin/investors/${id}`, method: 'GET' }),
      providesTags: (result, error, id) => [{ type: 'Investor', id }],
    }),
    createInvestor: builder.mutation({
      query: (body) => ({ url: '/admin/investors', method: 'POST', data: body }),
      invalidatesTags: [{ type: 'Investor', id: 'LIST' }],
    }),
    createInvestorManual: builder.mutation({
      query: (formData) => ({ url: '/admin/investors/manual', method: 'POST', data: formData }),
      invalidatesTags: [{ type: 'Investor', id: 'LIST' }],
    }),
    updateInvestor: builder.mutation({
      query: ({ id, ...body }) => ({ url: `/admin/investors/${id}`, method: 'PUT', data: body }),
      invalidatesTags: (result, error, { id }) => [{ type: 'Investor', id }],
    }),
    deleteInvestor: builder.mutation({
      query: (id) => ({ url: `/admin/investors/${id}`, method: 'DELETE' }),
      invalidatesTags: [{ type: 'Investor', id: 'LIST' }],
    }),
    activateInvestor: builder.mutation({
      query: (id) => ({ url: `/admin/investors/${id}/activate`, method: 'PATCH' }),
      invalidatesTags: (result, error, id) => [{ type: 'Investor', id }],
    }),
    deactivateInvestor: builder.mutation({
      query: (id) => ({ url: `/admin/investors/${id}/deactivate`, method: 'PATCH' }),
      invalidatesTags: (result, error, id) => [{ type: 'Investor', id }],
    }),
  }),
});

export const {
  useListInvestorsQuery,
  useGetInvestorQuery,
  useCreateInvestorMutation,
  useCreateInvestorManualMutation,
  useUpdateInvestorMutation,
  useDeleteInvestorMutation,
  useActivateInvestorMutation,
  useDeactivateInvestorMutation,
} = investorsApi;
